import { render, staticRenderFns } from "./MailingAssessments.vue?vue&type=template&id=318dc0e2&"
import script from "./MailingAssessments.vue?vue&type=script&lang=js&"
export * from "./MailingAssessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports